import { useQuery } from '@tanstack/react-query';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';
import { ImageType, PriceType } from './useProducts';

export enum ProductSpecsEnum {
  description = 'description',
  material = 'material',
  fitting = 'fitting',
  maintenance = 'maintenance',
  deliveryPromess = 'deliveryPromess',
  manufacturing = 'manufacturing',
  nextProductAvailability = 'nextProductAvailability',
}

export type ProductType = {
  id: number;
  name: string;
  slug: string;
  price: PriceType;
  priceOverwrite: PriceType;
  forceDisplay: number;
  dematerialized: number;
  dematerializedItemType: string;
  [ProductSpecsEnum.description]: string;
  [ProductSpecsEnum.material]: string;
  [ProductSpecsEnum.fitting]: string;
  [ProductSpecsEnum.maintenance]: string;
  [ProductSpecsEnum.deliveryPromess]: string;
  [ProductSpecsEnum.manufacturing]: string;
  [ProductSpecsEnum.nextProductAvailability]: string;
  localizedImages?: ImageType[];
  defaultImages?: ImageType[];
  gift: number;
};

export interface ProductFilter {
  productSlug?: string;
}

export default function useProduct(filter: ProductFilter) {
  const { licenseId, localeId, productSlug } = useLocaleQueryFilter(filter);
  const accessPhysicalProduct = window.config?.ACCESS_PHYSICAL_PRODUCT;
  const accessBonus = window.config?.ACCESS_BONUS;

  return useQuery<ProductType, Error>(
    [
      'products/findOne',
      { licenseId, localeId, productSlug, accessPhysicalProduct, accessBonus },
    ],
    {
      staleTime: 1000,
      enabled:
        !!licenseId &&
        !!localeId &&
        !accessPhysicalProduct !== undefined &&
        accessBonus !== undefined &&
        !!productSlug?.length,
    },
  );
}
